import { render, staticRenderFns } from "./feature-availability.vue?vue&type=template&id=08be48f7&scoped=true"
import script from "./feature-availability.vue?vue&type=script&lang=js"
export * from "./feature-availability.vue?vue&type=script&lang=js"
import style0 from "./feature-availability.vue?vue&type=style&index=0&id=08be48f7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08be48f7",
  null
  
)

export default component.exports